/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/28/21
 */

import React from "react";
import {Popover, Stack, useTheme} from "@mui/material";
import {Employee} from "../interfaces/Global";
import EmployeeDetails from "./EmployeeDetails";
import {useSelector} from "react-redux";
import {State} from "../state/store";
import countryNames from "../const/country-names";

export interface EmployeeCellProps {
	employee: Employee
}

export default function EmployeeCell({ employee }: EmployeeCellProps) {

	const showFlags = useSelector((s:State) => s.settings.showCountryFlags);

	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

	const handleClick = (event: React.MouseEvent<any>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const theme = useTheme();

	return (
		<Stack sx={{ textAlign: "right", pr: 1 }}>
			<Stack
				direction={"row"}
				alignItems={"center"}
				justifyContent={"flex-end"}
				onClick={handleClick}
				sx={{ cursor: "pointer" }}
				spacing={.5}
			>
				<Stack
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						color: "primary.main"
					}}
				>
					{employee.displayName}
				</Stack>
				{showFlags &&
					<Stack>
						<img src={"https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.5/flags/4x3/"
							+ (employee.countryCode === "UK" ? "GB" : employee.countryCode ?? "").toLowerCase() + ".svg"}
						     alt={countryNames[employee.countryCode ?? ""]}
						     width={20}
						     style={{
							     border: "1px solid " + theme.palette.grey[theme.palette.mode === "light" ? "300" : "700"]
						     }}
						/>
					</Stack>}
			</Stack>
			<Popover
				open={anchorEl !== null}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<EmployeeDetails
					employee={employee}
				/>
			</Popover>
		</Stack>
	);

}